// extracted by mini-css-extract-plugin
export default {"itemHeader":"ManagementAreaDetail_itemHeader__WS0GG","itemContent":"ManagementAreaDetail_itemContent__5N0sp"};